import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OrderLayoutService {

  creditCheckTemplate = [{
    name: 'customer-information',
    title: 'Credit Check',
    subHeader: 'Review the customer information below.'
  }, {
    name: 'customer-preferences',
    title: 'Credit Check',
    subHeader: 'Review the customer information below.'
  }, {
    name: 'customer-information-quality-check',
    title: 'Credit Information Quality Check',
    subHeader: 'Verify customer\'s information below'
  }]

  creditCheckSignal = signal('')
  pageHeader = signal('')
  subHeader = signal('')

  constructor() { }

  getCreditCheckTitleForProvider(provider: string): string {
    const isCharter = ['SPECTRUM'].includes(provider?.toUpperCase())
    return isCharter ? 'Customer Information Collection' : 'Credit Check'
  }
}
